export default "__VITE_ASSET__jAn3sbMj__"